import {
    addEventIdea,
    addEventIdeaComment,
    deleteEventIdea,
    updateEventIdea
} from "../Ideas/BrowserDatabaseFunctions";


export const E_addEventIdeaResults = async (_incoming) => {
    console.log("E_addNewIdeaResults");

    try {
        if (_incoming?.result !== "ok") {
            console.log("Add result not ok");
            return null;
        }

        const eventId = _incoming.event_id;
        const newIdea = _incoming.idea; // should already contain { id, temp_id?, ... }

        if (!eventId || !newIdea) {
            console.error("Missing event_id or idea in payload");
            return null;
        }

        // Persist to browser DB (best-effort)
        try {
            await addEventIdea(eventId, newIdea);
            console.log("Idea added successfully");
        } catch (error) {
            console.error("Error adding Idea to Browser database: ", error);
        }

        return null;

    } catch (e) {
        console.log("ERROR:", e);
        return null;
    }
};

export const E_updateEventIdeaResults = async (_incoming) => {
    console.log("E_updateEventIdeaResults");

    /*
        an Event Idea was updated
     */

    try {
        const _result = _incoming.result;

        if (_result === "ok") {
            try {
                await updateEventIdea(_incoming.event_id, _incoming.idea);
                console.log("Idea updated successfully");
            } catch (error) {
                console.error("Error updating Idea: ", error);
            }

            return null; // Return the updated idea regardless of success or failure

        } else {
            console.log("Update result not ok");
            return null; // Return null if the result is not ok
        }

    } catch (e) {
        console.log("ERROROROR : " + e);
        return null; // Return null if there was a top-level error
    }
}

export const E_addEventIdeaCommentResults = async (_incoming) => {
    console.log("E_addEventIdeaCommentResults : ", _incoming);

    /*
        an Event Idea was updated
     */

    try {
        const _result = _incoming.result;

        if (_result === "ok") {
            try {
                await addEventIdeaComment(_incoming.event_id, _incoming.idea_id, _incoming.comment);
                console.log("Idea comment updated successfully");
            } catch (error) {
                console.error("Error updating Idea: ", error);
            }

            return null; // Return the updated idea regardless of success or failure

        } else {
            console.log("Update result not ok");
            return null; // Return null if the result is not ok
        }

    } catch (e) {
        console.log("ERROROROR : " + e);
        return null; // Return null if there was a top-level error
    }
}

export const E_deleteEventIdeaResults = async (_incoming) => {
    console.log("E_deleteEventIdeaResults");

    /*
        an Event Idea was deleted
     */


    try {

        const _result = _incoming.result;

        if (_result === "ok") {

            try {
                await deleteEventIdea(_incoming.event_id, _incoming.idea_id);
                console.log("Idea deleted successfully");
            } catch (error) {
                console.error("Error deleting Idea: ", error);
            }

        }
    } catch (e){
        console.log("ERROROROR : "+e);
    }

}